export class EtiquetaController {
  constructor($scope) {
    "ngInject";

    this.$scope = $scope;
  }

  $onInit() {
    this.$scope.vmMain = this.vmMain;
  }
}
